import React from 'react'

const Announcements = (props) => {
  const { announcements } = props;
  let count = -1;
  let list;
  if (announcements.length > 0) {
    list = announcements.map(item => {
      count++;
      return (
        <div key={count} className="card mx-5 mb-3">
          <div className="card-header">
            {item.fields.titulo}
          </div>
          {item.fields.imagen &&
            <img className="cover" alt="Imagen de Eidefut" src={item.fields.imagen.fields.file.url} />
          }
          <div className="card-body">
            {item.fields.contenido.content[0].content[0].value}
          </div>
        </div>
      )
    })
  } else {
    list = <h3>Aún no hay anuncios disponibles</h3>
  }


  return (
    <div>
      <h1>Anuncios</h1>
      {list}
    </div>

  );
}
export default Announcements;